import { computed, onMounted, onUnmounted, ref } from 'vue';

export type Direction = 'ltr' | 'rtl' | 'auto';

export function useDir() {
  const dir = ref<Direction>('ltr');

  let observer: MutationObserver | null = null;

  const updateDir = () => {
    const currentDir = document.documentElement.dir;
    dir.value = (currentDir as Direction) || 'ltr';
  };

  const isRtl = computed(() => dir.value === 'rtl');
  const isLtr = computed(() => dir.value === 'ltr');

  onMounted(() => {
    updateDir();
    observer = new MutationObserver(updateDir);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['dir'],
    });
  });

  onUnmounted(() => {
    observer?.disconnect();
  });

  return {
    dir,
    isRtl,
    isLtr,
  };
}
